import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/CloudUpload.svg'

export const IconCloudUpload = IconSVG as IconComponent
